<template>
  <mt-swipe class="banner">
    <mt-swipe-item v-for="(item,index) in list" :key="index">
      <a href="javascript:;" @click="onClick(item)">
        <img :src="item.picture">
      </a>
    </mt-swipe-item>
  </mt-swipe>
</template>
<script>
  import {Swipe, SwipeItem} from 'mint-ui'

  export default {
    components: {
      'mt-swipe': Swipe,
      'mt-swipe-item': SwipeItem
    },
    computed: {
      list () {
        return this.$service.other.banner
      }
    },
    methods: {
      onClick (item) {
        if (item.type === 'movie') {
          this.$router.push({
            name: 'movie',
            params: {
              movid: item.val
            }
          })
        } else if (item.type === 'category') {
          this.$router.push({
            name: 'bookshelf',
            params: {
              catid: item.val
            }
          })
        } else if (item.type === 'link') {
          window.location = item.val
        }
      }
    }
  }
</script>
<style scoped lang='scss'>
  .banner {
    height: rem(270);
    max-height: 200px;
    background-color: $color-black;
    text-align: center;
    img {
      height: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// Banner.vue?6a4f1774